import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withKeys as _withKeys, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "select-container-dashboard"
}
const _hoisted_3 = { class: "img-container-modifier" }
const _hoisted_4 = {
  key: 0,
  class: "drop-container",
  role: "menu"
}
const _hoisted_5 = { id: "liste-deroulante" }
const _hoisted_6 = ["alt", "src"]
const _hoisted_7 = { class: "info-icon-wrapper" }
const _hoisted_8 = ["alt", "src"]
const _hoisted_9 = {
  key: 0,
  class: "custom-tooltip"
}
const _hoisted_10 = { class: "container-modale" }
const _hoisted_11 = { class: "center" }
const _hoisted_12 = { class: "container-modale" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ReglePastille = _resolveComponent("ReglePastille")!
  const _component_ButtonWhite = _resolveComponent("ButtonWhite")!
  const _component_DropDown = _resolveComponent("DropDown")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_HomeMain = _resolveComponent("HomeMain")!
  const _component_EditionDashboard = _resolveComponent("EditionDashboard")!
  const _component_ModaleCreationDashboard = _resolveComponent("ModaleCreationDashboard")!
  const _component_LoaderComponent = _resolveComponent("LoaderComponent")!
  const _component_ReglesMenusPanneau = _resolveComponent("ReglesMenusPanneau")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isClient && _ctx.dashboardLoaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_ReglePastille, { cle: "dashboard.personnalisableClientUniquement" }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_ButtonWhite, {
              id: "bouton-modifier-dashboard",
              onClick: () => (_ctx.plusActionOuvert = !_ctx.plusActionOuvert),
              "start-tour": _ctx.tourEnCours,
              text: _ctx.$t('editable.input.edit'),
              class: "bouton-modifier",
              onStarttour: _ctx.startTour
            }, null, 8, ["onClick", "start-tour", "text", "onStarttour"]),
            (_ctx.plusActionOuvert)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("div", {
                    id: "editer-dashboard",
                    class: "edition-dashboard",
                    role: "menuitem",
                    tabindex: "0",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editer && _ctx.editer(...args))),
                    onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.editer && _ctx.editer(...args)), ["enter"]))
                  }, _toDisplayString(_ctx.$t('dashboard.parametrable.editer')), 33),
                  _createElementVNode("div", {
                    class: "edition-dashboard",
                    role: "menuitem",
                    tabindex: "0",
                    onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dupliquer && _ctx.dupliquer(...args))),
                    onKeyup: _cache[3] || (_cache[3] = _withKeys(
//@ts-ignore
(...args) => (_ctx.dupliquer && _ctx.dupliquer(...args)), ["enter"]))
                  }, _toDisplayString(_ctx.$t('dashboard.parametrable.dupliquer')), 33),
                  _createElementVNode("div", {
                    class: "edition-dashboard texte-rouge",
                    role: "menuitem",
                    tabindex: "0",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.supprimer && _ctx.supprimer(...args))),
                    onKeyup: _cache[5] || (_cache[5] = _withKeys(
//@ts-ignore
(...args) => (_ctx.supprimer && _ctx.supprimer(...args)), ["enter"]))
                  }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('dashboard.parametrable.supprimer')) + " ", 1),
                    _createVNode(_component_ReglePastille, { cle: "dashboard.suppressionFavoriInterdite" })
                  ], 32)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_DropDown, {
              display: _ctx.displayDashboard,
              "label-creation": _ctx.$t('dashboard.parametrable.ajout.dashbboard'),
              "label-vide": _ctx.$t('dashboard.parametrable.liste.vide'),
              list: _ctx.listeDashboard,
              "selected-item": _ctx.selectedDashboard,
              width: '130%',
              class: "select-dashboard-dropdown",
              label: "",
              onCreation: _ctx.creerDashboard,
              onSelect: _ctx.setSelectedDashboard
            }, null, 8, ["display", "label-creation", "label-vide", "list", "selected-item", "onCreation", "onSelect"]),
            _createVNode(_component_ReglePastille, { cle: "dashboard.dashboardAffichePardDefaut" })
          ]),
          _createElementVNode("img", {
            alt: _ctx.$t('dashboard.parametrable.modale.info.favori'),
            src: _ctx.loadIconFavori,
            class: "icon cursor-pointer",
            role: "button",
            tabindex: "0",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.mettreFavori && _ctx.mettreFavori(...args))),
            onKeyup: _cache[7] || (_cache[7] = _withKeys(
//@ts-ignore
(...args) => (_ctx.mettreFavori && _ctx.mettreFavori(...args)), ["enter"]))
          }, null, 40, _hoisted_6),
          _createVNode(_component_ReglePastille, { cle: "dashboard.favoriIrreversibleIci" }),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("img", {
              id: "image-info",
              alt: _ctx.$t('dashboard.parametrable.edition.titre'),
              src: _ctx.loadInfoIcon,
              class: "cursor-pointer",
              role: "button",
              tabindex: "0",
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.startOnBoarding && _ctx.startOnBoarding(...args))),
              onKeyup: _cache[9] || (_cache[9] = _withKeys(
//@ts-ignore
(...args) => (_ctx.startOnBoarding && _ctx.startOnBoarding(...args)), ["enter"]))
            }, null, 40, _hoisted_8),
            (_ctx.tooltipVisible && !_ctx.actualitesOpen)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_ctx.$t('dashboard.tooltip.home')), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isModaleOpen)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 1,
          onCancel: _ctx.cancel
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("h2", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('dashboard.choix.portail.titre')) + " ", 1),
                _createVNode(_component_ReglePastille, { cle: "dashboard.choixPortailModale" })
              ]),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("button", {
                  id: "bouton-choix-portail-client",
                  class: "bouton bouton-client",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.goToHomePage && _ctx.goToHomePage(...args)))
                }, _toDisplayString(_ctx.$t('dashboard.choix.portail.client')), 1),
                _createElementVNode("button", {
                  class: "bouton bouton-fournisseur",
                  onClick: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.goToDashboardFournisseur && _ctx.goToDashboardFournisseur(...args)))
                }, _toDisplayString(_ctx.$t('dashboard.choix.portail.fournisseur')), 1)
              ])
            ])
          ]),
          _: 1
        }, 8, ["onCancel"]))
      : (_ctx.isConnected && !_ctx.modeEdition && _ctx.dashboardLoaded)
        ? (_openBlock(), _createBlock(_component_HomeMain, { key: 2 }))
        : _createCommentVNode("", true),
    (_ctx.modeEdition && _ctx.isConnected)
      ? (_openBlock(), _createBlock(_component_EditionDashboard, { key: 3 }))
      : _createCommentVNode("", true),
    (_ctx.modaleCreationDashboardOuverte)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 4,
          onCancel: _cache[14] || (_cache[14] = ($event: any) => (_ctx.modaleCreationDashboardOuverte = false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_ModaleCreationDashboard, _mergeProps(_ctx.dashboardADupliquer ? { dashboardADupliquer: _ctx.dashboardADupliquer } : {}, {
              onCancel: _cache[12] || (_cache[12] = ($event: any) => (_ctx.modaleCreationDashboardOuverte = false)),
              onCreationDashboardSuccess: _ctx.dashboardCreationSuccess,
              onDuplicationDashboardSuccess: _cache[13] || (_cache[13] = ($event: any) => (_ctx.dashboardCreationSuccess(true)))
            }), null, 16, ["onCreationDashboardSuccess"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.modaleAlerte)
      ? (_openBlock(), _createBlock(_component_Modal, {
          key: 5,
          onCancel: _cache[15] || (_cache[15] = ($event: any) => (_ctx.modaleAlerte = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.texteAlerte), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isLoading || !_ctx.dashboardLoaded)
      ? (_openBlock(), _createBlock(_component_LoaderComponent, {
          key: 6,
          class: "loader"
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ReglesMenusPanneau)
  ]))
}